<template>
	<div style="background-color: #161816;position: relative;width: 100%;min-width: 1200px;">
		<img style="image-rendering: -webkit-optimize-contrast!important;" src="../assets/images/home/loginlogo.png" alt="" class="logo_new">
		<!--    <div class="container-fluid container" style="position:relative;">-->
		<!--      <div class="navbar-header" style="position: relative;">-->
		<!--        <img src="../assets/images/home/flag1.png" alt="" class="logo_flag">-->
		<!--      </div>-->
		<!--    </div>-->
		<div class="" style="background-color: #161816;margin-right: 35px!important;">
		<nav class="app-nav" style="margin-left: 150px">
			<ul class="ul-father">
			<li class="li-father">
				<a @click="jumpUrl(arr[0].url)">{{ arr[0].title }}</a>
			</li>
			<li class="li-father">
				<a @click="jumpUrl(arr[1].url)">{{ arr[1].title }}</a>
			</li>
			<li class="li-father">
				<a @click="jumpUrl(arr[2].url)">{{ arr[2].title }}</a>
			</li>
			<li class="li-father">
				<a @click="jumpUrl(arr[3].url)">{{ arr[3].title }}</a>
			</li>
			<li class="li-father">
				<template v-if="user.userTypeEnum === 'MANAGER'">
				<!--<router-link @click="jumpUrl(arr[4].url)" v-bind:to='arr[4].url' target='_blank'>{{ arr[4].title }}</router-link>-->
					<a @click="jumpUrl(arr[4].url)">{{ arr[4].title }}</a>
				</template>
				<template v-else>
					<a @click="jumpUrl(arr[4].url)">{{ arr[4].title }}</a>
				</template>
			</li>
			<li class="li-father">
				<template v-if="user.type===-1">
					<a @click="showLoginModal">{{ arr[5].title }}</a>
				</template>
				<template v-else>
          <div style="display:inline-block;font-size: 16px;border-left: 1px solid #eee;height: 30px;line-height: 30px;"
            onmouseover="ulChild.style.display='block'" onmouseout="ulChild.style.display='none'">
            <i class="el-icon-user-solid" style="margin: 0 20px"></i>
            {{user.userName}}
          </div>
          <ul id="ulChild" class="ul-child" style="display: none;z-index: 99;"
            onmouseover="ulChild.style.display='block'"
            onmouseout="ulChild.style.display='none'"><!--onmouseout="ulChild.style.display='none'"-->
            <li><a @click="updatePassword()" style="cursor: pointer;font-size: 15px">修改密码</a></li>
            <li><a @click="logout()" style="cursor: pointer;font-size: 15px">退出登录</a></li>
          </ul>
				</template>
			</li>
			</ul>
		</nav>
		</div>

		<!--修改密码-->
		<el-dialog ref="tree" title="修改密码" v-if="updatePasswordDialog" :visible.sync="updatePasswordDialog" v-dialogDrag
				:close-on-click-modal="false" destroy-on-close append-to-body width="440px">

			<el-form :label-position="labelPosition" label-width="90px" :model="updatePasswordForm" ref="updatePasswordForm"
					size="mini" :rules="userRules">
				<el-form-item label="旧密码:" prop="oldPassword">
				<el-input v-model="updatePasswordForm.oldPassword" placeholder="请输入旧密码" show-password></el-input>
				</el-form-item>
				<el-form-item label="新密码:" prop="newPassword">
				<el-input v-model="updatePasswordForm.newPassword" placeholder="请输入新密码" show-password></el-input>
				</el-form-item>
				<el-form-item label="确定密码:" prop="endNewPassword">
				<el-input v-model="updatePasswordForm.endNewPassword" placeholder="请确认密码" show-password></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click="saveUpdatePassword('updatePasswordForm')">保 存</el-button>
				<el-button size="mini" type="danger" @click="updatePasswordDialog = false">关 闭</el-button>
			</div>
		</el-dialog>
		<login-modal ref="loginModal"></login-modal>
    <BindingModal ref="bindingModal" :bindState="loginState" :bindType="loginType"></BindingModal>
  	</div>
</template>

<script>
  import api from '../api'
  import {mapActions, mapState} from 'vuex'
  import router from "../router/index";
  import {successPromptData, promptData} from "../util/MessageTools";
  import loginModal from '../page/Login/LoginModal'
  import BindingModal from './Binding/BindingModal.vue'
  import {vuexTimeData} from "../util/vuexData";

  export default {
    name: 'header1',
	components: {
    BindingModal,
		loginModal
	},
    computed: mapState([
      'user'
    ]),
    data() {
      return {
        a: false,
        labelPosition: 'left',
        updatePasswordDialog: false,
        updatePasswordForm: {
          oldPassword: "",
          newPassword: "",
          endNewPassword: "",
        },
        arr: [
          {
            title: '首页',
            url: '/',
          }, {
            title: '我要报名',
            url: '/enter_for',
          }, {
            title: '我的投稿',
            url: '/contribute'
          }, {
            title: '我的审稿',
            url: '/reader'
          }, {
            title: '管理',
            url: '/admin/user'
          }, {
            title: '登录/注册',
            show: false,
            url: '/login',
          }
        ],
        userRules: {
          oldPassword: [
            {required: true, message: '请输入旧密码', trigger: 'submit'},
          ],
          newPassword: [
            {required: true, message: '请输入新密码', trigger: 'submit'},
          ],
          endNewPassword: [
            {required: true, message: '请确认密码', trigger: 'submit'},
          ],
        },
        loginType:null,
        loginState:null
      }
    },

    methods: {
      ...mapActions([
        'setUser'
      ]),
	  /**
	   * 显示登录弹窗
	   */
	  showLoginModal(){
		  this.$refs.loginModal.loginModalStatus = true;
	  },
	  /**
	   * 导航跳页
	   */
	  jumpUrl(url){
      //判断是否登录，没登录不跳页
      if(this.user.type== -1 && url!='/'){
        promptData('请先登录!',this)
        return false
      }
      this.$router.push({
        path:url
      })
	  },
      /**
       * 退出登录
       */
      logout() {
        let vue = this
        api.login.logout().then(function (response) {
          if (response.data.code === '0') {
            let user = {}
            user.type = -1
            router.app.$options.store.state.user = user
            let localStorage = window.localStorage;
            if (localStorage) {
              localStorage.removeItem('thesis-userToken');
            }
            window.location.reload()
            // router.replace({
            //   path: '/',
            //   query: {
            //     // redirect: router.currentRoute.fullPath
            //   }
            // })
          } else {
            promptData('退出失败请联系管理员!', this)
          }
        })

      },

      /**
       *修改密码
       */
      updatePassword() {
        this.updatePasswordForm.oldPassword = ""
        this.updatePasswordForm.newPassword = ""
        this.updatePasswordForm.endNewPassword = ""
        this.updatePasswordDialog = true
      },
      /**
       *保存修改的密码
       */
      saveUpdatePassword(formName) {
        let id = this.user.userId
        let vue = this
        this.$refs[formName].validate((valid) => {
            if (valid) {
              let oldPassword = this.updatePasswordForm.oldPassword
              let newPassword = this.updatePasswordForm.newPassword
              let endNewPassword = this.updatePasswordForm.endNewPassword
              if (newPassword !== endNewPassword) {
                promptData("两次输入的新密码不一样,请检查!", this)
                return
              }
              api.user.updatePwd(id, oldPassword, newPassword).then(function (response) {
                if (response == null) {
                  return null
                }
                if (response.data.code === "0") {
                  vue.updatePasswordDialog = false
                }
              })
            }
          }
        );
      },

      /**
       * 获取导航栏拼接的参数
       * @param name
       * @returns {string|null}
       */
      getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]);
        return null;
        // let after = window.location.hash.split("?")[1];
        // if (after) {
        //   let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        //   let r = after.match(reg);
        //   if (r != null) {
        //     return decodeURIComponent(r[2]);
        //   } else {
        //     return null;
        //   }
        // }
      },

      /**
       * 给VUEX赋值
       */
      vuexToValue(result) {
        let userInfo = {}
        let localStorage = window.localStorage;
        if (localStorage) {
          if (result.userToken === "" || result.userToken == null || result.userToken == undefined) {
            userInfo.userToken = localStorage.getItem('thesis-userToken');
          } else {
            localStorage.setItem('thesis-userToken', result.userToken);
          }
        }
        userInfo.userToken = result.userToken
        userInfo.userId = result.id
        userInfo.userName = result.userName
        userInfo.userTypeEnum = result.userTypeEnum
        userInfo.certificateStatus = result.certificateStatus
        userInfo.userPhone = result.userPhone
        userInfo.type = 1
        router.app.$options.store.state.user = userInfo;
        return userInfo
      },

      fromQQBind(state,type){
        // console.log(state)
        // console.log(type)
        if(state != undefined && type != undefined && state != '' && type != '') {
          this.loginType = 'qq'
          this.loginState = state
          this.$refs.bindingModal.bindingModalStatus = true
        }
      }


    },

    mounted() {
      let that = this
      let code = this.getQueryString('code')
      let state = this.getQueryString('state')
      if (code != null && state != null && code !== "" && state !== "") {
        let url = window.location.href;
        if (url.indexOf("?") != -1) {
          url = url.replace(/(\?|#)[^'"]*/, '');
          window.history.pushState({}, 0, url);
        }
        api.login.loginCallback(code, state).then(function (response) {
          if (response == null) {
            return null
          }
          if (response.data.code === "0") {
            let result1 = response.data.result
            that.vuexToValue(result1)
            if (typeof (result1.state) === 'undefined') {
              api.login.getGameInfo().then(function (response) {
                if (response == null) {
                  return null
                }
                if (response.data.code === "0") {
                  let result = response.data.result
                  vuexTimeData(result)
                }
              })
            } else {//当前微信暂未绑定本平台账号,请先绑定
              that.loginType = 'vx'
              that.loginState = state
              that.$refs.bindingModal.bindingModalStatus = true
              that.$refs.bindingModal.test();
            }
          }
        })
      }


    },
    created() {
      /* let user = {}
       user.type = -1
       this.setUser(user)*/
      this.$busEvent.$on('onBindingQQ',this.fromQQBind)
    }
  }
</script>

<style scoped>
  .app-nav {
    /*margin-bottom: 20px;*/
  }

  ul.ul-father {
    background: Lightgreen;
    background: #161816;
    margin: 0;
    text-align: right;
    color: #fff;
  }

  .li-father {
    position: relative;
    display: inline-block;
    /*width: 16%;*/
    margin: 0;
  }

  li a {
    display: block;
    padding: 12px 23px;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    height: 65px;
    line-height: 43px;
    font-family: 微软雅黑;
    letter-spacing: 2px;
    text-shadow: 0 0 1px #fff;
    opacity: 0.8;
  }

  li a:hover, .bgchange > a {
    /*color: #fff;*/
    /*background: #222;*/
    /*border-bottom: 2px solid #1c3784;*/
    background-color: rgba(255, 255, 255, 0.2);
    background-color: #398f63;
  }

  li a:focus {
    outline-offset: 0px;
    background-color: rgba(255, 255, 255, 0.2);
    outline: -webkit-focus-ring-color auto 0px;
  }

  .ul-child {
    list-style-type: none;
    position: absolute;
    top: 30px;
    /*left: -35px;*/
    right: -30px;
    width: 140px;
    height: auto;
    /* background: Lightgreen;*/
  }

  .ul-child li {
    background-color: #0c1a41 !important;
    background-color: #161816 !important;
    color: #FFF !important;
    box-shadow: none;
  }

  .ul-child li a {
    padding-left: 0px !important;
    padding-right: 0px !important;
    width: 100% !important;
    margin: 0 !important;
    text-align: center !important;
  }

  .upsideHeader {
    height: 50px;
    background-color: #1c3784;
    width: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/page/Header.vue